<template>
  <StepSubmit
    v-if="id === 'submit'"
    v-model="computedValue"
    :message="message"
    :data="data"
    :loading="loading"
    @submit="onSubmit"
  />
  <StepAsset
    v-else-if="id === 'asset'"
    v-model="computedValue"
    :message="message"
    :data="data"
    @next="onNext"
  />
  <StepJobNumber
    v-else-if="id === 'job_number'"
    v-model="computedValue"
    :message="message"
    :data="data"
    @next="onNext"
  />
  <StepOdometer
    v-else-if="id === 'odometer'"
    v-model="computedValue"
    :message="message"
    :data="data"
    @next="onNext"
  />
  <StepName
    v-else-if="id === 'name'"
    v-model="computedValue"
    :message="message"
    :data="data"
    @next="onNext"
  />
  <StepPhone
    v-else-if="id === 'phone'"
    v-model="computedValue"
    :message="message"
    :data="data"
    @next="onNext"
  />
  <div class="form-step" v-else>
    <ion-grid class="form-step-content">
      <ion-row v-if="section">
        <ion-col>
          <span>
            {{ section.text }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <h1 class="form-question">
            {{ title }}
          </h1>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <form-component-renderer
            :component="component"
            v-model="computedValue"
            @next="onNext"
            @prev="onPrev"
          />
        </ion-col>
      </ion-row>
      <ion-row v-if="message">
        <ion-col>
          <slot name="invalid">
            <ion-chip color="danger">
              <ion-label>{{ message }}</ion-label>
            </ion-chip>
          </slot>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import template from "string-template";

import StepAsset from "./FormSteps/StepAsset.vue";
import StepSubmit from "./FormSteps/StepSubmit.vue";
import StepOdometer from "./FormSteps/StepOdometer.vue";
import StepJobNumber from "./FormSteps/StepJobNumber.vue";
import StepName from "./FormSteps/StepName.vue";
import StepPhone from "./FormSteps/StepPhone.vue";

import FormComponentRenderer from "../components/FormComponents/FormComponentRenderer.vue";

export default {
  name: "FormStep",
  components: {
    FormComponentRenderer,
    StepSubmit,
    StepAsset,
    StepJobNumber,
    StepOdometer,
    StepName,
    StepPhone
  },
  props: ["errors", "data", "loading", "component"],
  model: {
    prop: "data",
    event: "input"
  },
  computed: {
    id() {
      return this.component.id;
    },
    message() {
      return this.errors[this.id];
    },
    title() {
      return this.parseTitle(this.component.title);
    },
    section() {
      return this.component.section;
    },
    computedValue: {
      get() {
        return this.data[this.id];
      },
      set(value) {
        this.$emit("check", value, this.id);
        this.$emit("input", { ...this.data, [this.id]: value });
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit("submit");
    },
    onNext() {
      this.$emit("next");
    },
    onPrev() {
      this.$emit("prev");
    },
    parseTitle(title) {
      if (typeof title === "string") {
        return template(title, this.data);
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
.form-section {
  margin-top: 20px;
}

.form-question {
  margin-top: 0;
}
</style>

<style lang="scss">
.form-step {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  &-content {
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
  &-end {
    margin-top: auto;
  }
}
</style>
